module.exports = __webpack_public_path__ + "img/cover.a5c9a7ea.webp";